import { Injectable } from '@angular/core';
import { HttpService } from '../shared/services/http.service';
import { tap } from 'rxjs';
import { UserDTO } from '../models/UserDTO.model';
import { MasterdataRequestDTO } from '../models/MasterdataRequestDTO.model';
import { SimpleRequestDTO } from '../shared/models/SimpleRequest';
import { UserGroupDTO } from '../models/UserGroupDTO.model';
import { ApiRoutesEnum } from '../shared/enums/ApiRoutes.enum';
import { ResponseDataBoolean, ResponseListUserPartnerDTO } from '../shared/models/ApiResponse';
import { UserPartnerDTO } from '../models/UserPartnerDTO.model';
import { AwaitableObservable } from '../shared/AwaitableObservable';
import { UserRequestDTO } from '../shared/models/UserRequestDto';
import { TransferPartnerDTO } from '../models/TransferPartnerDTO.model';

@Injectable({
  providedIn: 'root'
})
export class DistributorsService {

  constructor(private http: HttpService) { }

  getMastersById(data: MasterdataRequestDTO) {
    return this.http.getMastersById(data).pipe(
      tap(() => {})
    );
  }

  getByIdAsync(distributorId: number): AwaitableObservable<UserDTO> {
    return this.http.postAsync<UserDTO>(ApiRoutesEnum.GET_USER_BY_ID, <UserRequestDTO>{ userId: distributorId });
  }

  getListDistributors() {
    return this.http.getListDistributors().pipe(
      tap(() => {})
    );
  }

  saveDistributor(distributor: UserDTO) {
    return this.http.saveDistributor(distributor).pipe(
      tap(() => {})
    );
  }

  getListPartnersByDistributorId(data: SimpleRequestDTO) {
    return this.http.getListPartnersByDistributorId(data).pipe(
      tap(() => {})
    );
  }

  getListPartnersAvailables() {
    return this.http.getListPartnersAvailables().pipe(
      tap(() => {})
    );
  }

  addPartnersDistributor(data: UserGroupDTO[]) {
    return this.http.addPartnersDistributor(data).pipe(
      tap(() => {})
    );
  }

  clearPartnersDistributor(data: SimpleRequestDTO) {
    return this.http.clearPartnersDistributor(data).pipe(
      tap(() => {})
    );
  }

  /**
   * This is the sample how to use new services
   * @deprecated Use getAllDistributorsAvailablesAsync()
   */
  getAllDistributorsAvailables() {
    return this.http.getAllDistributorsAvailables().pipe(
      tap(() => {})
    );
  }
  getAllDistributorsAvailablesAsync(): AwaitableObservable<TransferPartnerDTO[]> {
    return this.http.getAsync<TransferPartnerDTO[]>(ApiRoutesEnum.GET_ALL_DISTRIBUTORS_AVAILABLES);
  }

  updatePartnersDistributor(data: UserGroupDTO[]) {
    return this.http.updatePartnersDistributor(data).pipe(
      tap(() => {})
    );
  }

  getDistributorSummary(request: SimpleRequestDTO) {
    return this.http.getDistributorSummary(request).pipe(
      tap(() => {})
    );
  }

  exportToExcelListDistributors() {
    return this.http.exportToExcelListDistributors().pipe(
      tap(() => {})
    );
  }

  exportToExcelListDistributorPartners(request: SimpleRequestDTO) {
    return this.http.exportToExcelListDistributorPartners(request).pipe(
      tap(() => {})
    );
  }

  getListCustomersByDistributorIdAsync(distributorId?: number): AwaitableObservable<UserPartnerDTO[]> {
    return this.http.postAsync<UserPartnerDTO[]>(ApiRoutesEnum.GET_LIST_CUSTOMERS_BY_DISTRIBUTOR, {id: distributorId});
  }
    
  getListCustomersAvailablesAsync(): AwaitableObservable<UserPartnerDTO[]> {
    return this.http.getAsync<UserPartnerDTO[]>(ApiRoutesEnum.GET_LIST_CUSTOMERS_AVAILABLES_FOR_DISTRIBUTOR);
  }

  addCustomersDistributorAsync(data: UserGroupDTO[]): AwaitableObservable<boolean> {
    return this.http.postAsync<boolean>(ApiRoutesEnum.ADD_CUSTOMERS_DISTRIBUTOR, data);
  }

  clearCustomersDistributorAsync(data: SimpleRequestDTO): AwaitableObservable<boolean> {
    return this.http.postAsync<boolean>(ApiRoutesEnum.CLEAR_CUSTOMERS_DISTRIBUTOR, data);
  }

  updateCustomersDistributor(data: UserGroupDTO[]) {
    return this.http.postAsync<boolean>(ApiRoutesEnum.UPDATE_CUSTOMERS_DISTRIBUTOR, data);
  }

}
